import DriverListWithPhoto from '@/pages/Business/pages/Shippings/components/DriverListWithPhoto';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { MIN_SEARCH_LENGTH } from '../constants/assignDriver.constants';
import { useAssignDriver } from '../hooks/useAssignDriver';
import { GlobalButton } from '@/components';
import { SearchInput } from '@/components';
import { Modal } from '@mui/material';

export interface AssignDriverModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  routeId: string;
  logisticOperatorId: string;
  isReassignment?: boolean;
}

const AssignDriverModal = ({
  open,
  onClose,
  onSuccess,
  routeId,
  logisticOperatorId,
  isReassignment = false,
}: AssignDriverModalProps) => {
  const {
    searchName,
    setSearchName,
    selectedDriverId,
    setSelectedDriverId,
    isLoadingDrivers,
    isDriversError,
    drivers,
    hasSearched,
    isSubmitting,
    isReassignment: isReassignmentMode,
    handleAssign,
    handleClose,
  } = useAssignDriver({
    open,
    routeId,
    logisticOperatorId,
    onClose,
    onSuccess,
    isReassignment,
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-xl'>
        <div className='flex flex-col p-6 gap-4 bg-white outline-none rounded-lg shadow-xl max-h-[90vh]'>
          <h2 className='text-lg font-semibold text-gray-800'>
            {isReassignmentMode ? 'Reasignar conductor' : 'Asignar conductor'}
          </h2>

          <SearchInput
            name='driverSearch'
            placeholder={`Buscar por nombre (mín. ${MIN_SEARCH_LENGTH} caracteres)`}
            value={searchName}
            onChange={setSearchName}
          />

          {hasSearched && (
            <div className='flex flex-col min-h-[240px] overflow-hidden'>
              <DriverListWithPhoto
                loading={isLoadingDrivers}
                error={isDriversError}
                drivers={drivers}
                selectedId={selectedDriverId}
                onSelect={setSelectedDriverId}
              />
            </div>
          )}

          <div className='flex gap-3 justify-end pt-2'>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={handleClose}
              disabled={isSubmitting}
            >
              Cancelar
            </GlobalButton>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={handleAssign}
              disabled={!selectedDriverId || isSubmitting}
            >
              {isSubmitting
                ? isReassignmentMode
                  ? 'Reasignando…'
                  : 'Asignando…'
                : isReassignmentMode
                  ? 'Reasignar'
                  : 'Asignar'}
            </GlobalButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AssignDriverModal;
